var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicesSideBarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78906 13.4974L13.4799 2.80664M15.5273 9.21242L13.6944 11.0453M12.1301 12.591L11.3145 13.4066",
    stroke: "#4B5563",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64686 13.4503C1.34167 12.1451 1.34167 10.0289 2.64686 8.72377L8.72572 2.64491C10.0309 1.33972 12.1471 1.33972 13.4522 2.64491L17.3557 6.54844C18.661 7.85363 18.661 9.96977 17.3557 11.2749L11.2769 17.3538C9.97172 18.659 7.85559 18.659 6.5504 17.3538L2.64686 13.4503Z",
    stroke: "#4B5563",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 18.334H16.6654",
    stroke: "#4B5563",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesSideBarIcon);
export default __webpack_public_path__ + "static/media/services-side-bar-icon.1d438ed06387db92e797001c3918aff4.svg";
export { ForwardRef as ReactComponent };